// extracted by mini-css-extract-plugin
export default {"formSettings":"GsdjSWb7OLhMyvEYvCjj","tooltip":"mG0RWvLaPfRRij4m8Jbs"};